module.exports = __webpack_public_path__ + "r-v3/img/survey_color.083782e1.svg";